import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAIChatHistory } from '../AkademySlice';
import { Box, CircularProgress, Typography, useTheme } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';

import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';

import { secondsToString } from '../../../utils/helpers';
import moment from 'moment';
import StatsBox from './StatsBox';

function AkademyTalktimeConsumption() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { handleLoader } = useLoader();
  const { SuccessToast, ErrorToast } = useToast();

  const { aiChatHistory, loading } = useSelector(({ akademyReducer }) => {
    return {
      aiChatHistory: akademyReducer.aiChatHistory,
      loading: akademyReducer.loading,
    };
  });

  useEffect(() => {
    dispatch(getAIChatHistory({ origin: 'CONVERSATIONAL_BUDDIES' }));
  }, []);

  const talktimeConsumptionColumns = [
    {
      Header: 'Date',
      accessor: 'createdAt',
      Cell: (val) => {
        const { createdAt } = val.cell.row.original;

        return (
          <Typography>{moment(createdAt).format('DD MMM YYYY')}</Typography>
        );
      },
    },
    {
      Header: 'User',
      accessor: 'user.name',
      Cell: (val) => {
        const { user } = val.cell.row.original;

        return (
          <Typography>
            {user && user.name} | {user && user.email}
          </Typography>
        );
      },
    },
    {
      Header: 'School',
      accessor: 'school.name',
      Cell: (val) => {
        const { school } = val.cell.row.original;

        return <Typography>{school && school.name}</Typography>;
      },
    },
    {
      Header: 'Talktime Durations',
      // accessor: 'talktimeInSeconds',
      Cell: (val) => {
        const { chats } = val.cell.row.original;

        let talktimeInSeconds = chats.reduce((prevVal, { metadata }) => {
          return (
            prevVal +
            (metadata.promptAudioDuration || 0) +
            (metadata.answertAudioDuration || 0)
          );
        }, 0);

        return <Typography>{secondsToString(talktimeInSeconds)}</Typography>;
      },
    },
    {
      Header: 'AI Tokens',
      accessor: '',
      Cell: (val) => {
        const { chats } = val.cell.row.original;

        let aiTokens = chats.reduce((prevVal, { metadata }) => {
          return prevVal + (metadata.AItokens || 0);
        }, 0);

        return <Typography>{aiTokens}</Typography>;
      },
    },
  ];

  return (
    <Box>
      <StatsBox aiChatHistory={aiChatHistory} date={new Date()} />
      <StatsBox
        aiChatHistory={aiChatHistory}
        date={moment(new Date()).subtract(1, 'months')}
      />

      <Box mb={4}>
        {loading ? (
          <CircularProgress />
        ) : (
          <BuzzTable
            columns={talktimeConsumptionColumns}
            data={aiChatHistory}
            isHandlePagination={true}
          />
        )}
      </Box>
    </Box>
  );
}

export default AkademyTalktimeConsumption;
